import * as React from 'react';

type Props = {
  children: React.ReactNode
};

const CampaignBlank = (
  {
    children
  }: Props
): JSX.Element => (
  <section className="campaign-blank">
    <div className="campaign-blank__message">
      {children}
    </div>
  </section>
);

export default CampaignBlank;
